const webURL = 'https://test.admin.reposit.co.uk';
const clientId = 'sGtBxG4TXqSxUhffkr6wVB3VAgRYgnZ4';

export const appConfig = {
  links: {
    auth0: {
      logout: `https://reposit-test.eu.auth0.com/v2/logout?client_id=${clientId}`,
      login: `https://reposit-test.eu.auth0.com/authorize?response_type=token&client_id=${clientId}&redirect_uri=${webURL}/authenticate&audience=https://test.api.com&scope=ALL`,
    },
    local: {
      login: `${webURL}/login`,
    },
  },
  api: {
    basePath: 'https://test.api.reposit.co.uk',
  },
  earliestKpiDate: '2020-06-26',
  earliestReconciliationDate: '2023-01-01',
  hubspotPortalId: '9159844',
  inMaintenanceMode: false,
  newAdminUrl: 'https://test.admin-dashboard.reposit.co.uk',
  stripeDashboardUrl: 'https://dashboard.stripe.com/acct_1TEqArHh21g2P7V1/test',
};
